import React, { useState, useEffect } from "react";
import "./ProjectDetails.css";
import { getAllData, getAllDataWithFlag, getProjectById } from "../../../services/CommonService";
import { imgURL } from "../../Config";
import { Link, useParams } from "react-router-dom";
import moment from 'moment';
import EventPage from "../../../pages/EventPage";
import GalleryPage from "../../../pages/GalleryPage";
import PublicationsPage from "../../../pages/PublicationsPage";
import Publications from "../Publications/Publications";
import Swal from "sweetalert2";

const ProjectDetails = () => {
  const [projects, setProjects] = useState({});
  const { id } = useParams();

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await getAllDataWithFlag(5);
      const projectData = response?.data?.project;
      const filteredData = projectData?.find((m) => m.id == id);
      const typologyData = JSON.parse(localStorage.getItem('typologyData'));
      const themeData = JSON.parse(localStorage.getItem('themeData'));
      const masterData = JSON.parse(localStorage.getItem('StateMaster'));
      const stateIds = filteredData?.state?.split(',') || [];
      const districtIds = filteredData?.district?.split(',') || [];
      const typologyIds = filteredData?.typology?.split(',') || [];
      const themeIds = filteredData?.theme?.split(',') || [];
      const typologynames = typologyIds?.map(did => {
        return typologyData?.find(dt => dt?.id?.toString() === did.trim())?.typology;
      });
      const themenames = themeIds.map(did => {
        return themeData?.find(dt => dt.id?.toString() === did.trim())?.theme;
      });
      const statenames = stateIds.map(did => {
        return masterData?.state?.find(dt => dt.id_mststate?.toString() === did.trim())?.statename;
      })
      const districtnames = districtIds.map(did => {
        return masterData?.district?.find(dt => dt.id_mstdistrict?.toString() === did.trim())?.districtname;
      });
      filteredData.typologynames = typologynames;
      filteredData.themenames = themenames;
      filteredData.statenames = statenames;
      filteredData.districtnames = districtnames;
      setProjects(filteredData);
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err?.response?.data?.message || err?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
    }
  };

  const banners = JSON.parse(localStorage.getItem('banners'));
  const bannerItem = (banners || []).find((r) => r.banner_type == 5);
  const dateFormat = (d) => d ? moment(d).format('DD-MM-YYYY') : 'N/A';

  return (
    <div className="user-panel">
      {/* Header Banner */}
      <div className="position-relative">
        <img
          src={bannerItem?.image_path ? `${imgURL}${bannerItem?.image_path}` : '/assets/images/bannerDefault.jpg'}
          alt="Groundwater"
          className="img-fluid w-100"
          style={{ minHeight: '350px', maxHeight: '350px', objectFit: 'cover' }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.style.display = 'none';
          }}
        />
        <div className="container-fluid text-end z-1 position-absolute mt-3">
          <Link to={'../'}><button className='btn btn-sm btn-warning'><i className="bi bi-arrow-left me-1"></i>Back</button></Link>
        </div>
        <div className="position-absolute top-0 left-0 w-100 h-100 bg-dark" style={{ opacity: 0 }}></div>
        <div className="container position-relative" style={{ marginTop: '-65px' }}>
          <div className="bg-white rounded-3 shadow p-4 banner_overlay ">
            <h3 className="text-center mb-4 fw-bold text-truncate">{projects.title}</h3>
            <div className="text-center">
              <div className='eventtheme_layout'> <span className="px-4 py-2  ">Theme: {Array.isArray(projects?.themenames) ? projects?.themenames.join(', ') : projects?.themenames}</span></div>
            </div>
          </div>
        </div>
      </div>
      {/* Info Section */}
      <div className="container my-5" >
        <div className="row">
          <div className="col-lg-8 card p-3">
            {projects?.typologynames && <h2 className="fw-bold mb-4">Typology</h2>}
            <p className="ms-2">{Array.isArray(projects?.typologynames) ? projects?.typologynames.join(', ') : projects?.typologynames}</p>
            {projects.project_head_details && (<><h2 className="fw-bold mb-4">Project Head Details</h2>
              <p className="ms-2">{projects.project_head_details}</p></>)}
            {projects.donor && (<>
              <h2 className="fw-bold mb-4">Donor</h2>
              <p className="ms-2">{projects.donor}</p>
            </>)}
            {projects?.description && <h2 className="fw-bold mb-4">Descriptions</h2>}
            <p className="mb-3 ms-2" dangerouslySetInnerHTML={{ __html: projects?.description }}>
            </p>
            <h2 className="fw-bold mb-4">Project Area</h2>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>State</th>
                  <th>District(s)</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  const stateDistrictMap = {};
                  const masterData = JSON.parse(localStorage.getItem('StateMaster'));
                  const districtIds = projects?.district?.split(',') || [];
                  districtIds.forEach(did => {
                    const district = masterData?.district?.find(d => d.id_mstdistrict?.toString() === did.trim());
                    if (district) {
                      const stateId = district.id_mststate?.toString();
                      if (!stateDistrictMap[stateId]) {
                        stateDistrictMap[stateId] = {
                          stateName: masterData?.state?.find(d => d.id_mststate?.toString() === stateId)?.statename,
                          districts: []
                        };
                      }
                      stateDistrictMap[stateId].districts.push(district.districtname);
                    }
                  });
                  return Object.entries(stateDistrictMap)?.map(([stateId, { stateName, districts }]) => (
                    <tr key={stateId}>
                      <td>{stateName}</td>
                      <td>{districts.join(', ')}</td>
                    </tr>
                  ));
                })()}
              </tbody>
            </table>

          </div>
          <div className="col-lg-4">
            <div className="card mb-4 text-white" style={{ background: '#122B50' }}>
              <div className="card-header border-0">
                <h4 className="mb-0">Project Details</h4>
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-warning text-white rounded p-2 me-3">
                    <img src='/assets/images/event-date.png' className='eventImgIcon' />
                  </div>
                  <div>
                    <strong>{dateFormat(projects.start_date)} To {dateFormat(projects.end_date)}</strong>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-warning text-white rounded p-2 me-3">
                    <img src='/assets/images/event-time.png' className='eventImgIcon' />
                  </div>
                  <div>
                    <strong>{projects.lat}, {projects.longitude}</strong>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-warning text-white rounded p-2 me-3">
                    <img src='/assets/images/event-location.png' className='eventImgIcon' />
                  </div>
                  <div>
                    <strong>{Array.isArray(projects?.statenames) ? projects?.statenames.join(', ') : projects?.statenames}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {<EventPage projectId={id} />}
        {<GalleryPage projectId={id} />}
        {<Publications projectId={id} />}
        <div className="row">
          <div className="col-lg-8"></div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
